import { watch, type Ref, ref } from "vue";
import { useInterpolation } from "../animation/useInterpolation";
import { clamp, isDigit, lerp } from "math";
import { computedWithControl } from "@vueuse/core";

export type UseTweeenedNumberProps = {
  value: Ref<string>;
  duration?: number;
}

const interpChar = (a: string, b: string, f: number) => {
  if (isDigit(a) && isDigit(b)) {
    return Math.round(lerp(Number(a), Number(b), f)) + '';
  }
  if (isDigit(b) && !isDigit(a)) {
    return Math.round(lerp(0, Number(b), f)) + ''
  }

  return b;
  //const ca = a.charCodeAt(0);
  //const cb = a.charCodeAt(0);

  //return String.fromCharCode(Math.round(lerp(ca, cb, f)));
}

const interpString = (a: string, b: string, f: number) => {
  if (a.length <= 0 && b.length <= 0) return '';
  const pointsA = Array.from(a);
  const pointsB = Array.from(b);

  if (pointsB.length <= 0) return ' ';

  return pointsB.map((b, i) => interpChar(pointsA[i] ?? b, b, f)).join('');
}

export const useTweenedString = (props: UseTweeenedNumberProps) => {
  const initial = props.value.value;
  const next = ref<string>(initial);
  const count = ref<number>(0);
  const lerped = ref<string>(initial);

  const interp = useInterpolation({
    initial: 0,
    duration: props.duration || 1,
  });

  watch([props.value], async () => {
    lerped.value = next.value;
    next.value = props.value.value;
    await interp.run(0.0, 1.0);
    count.value += 1;
  }, { immediate: true });

  return computedWithControl([() => interp.state.value], () => {
    return interpString(lerped.value, next.value, clamp(interp.state.value*interp.state.value, 0, 1));
  });
}
